



























































































































import {Component, Prop, Watch, Vue} from 'vue-property-decorator';
import {groupBy} from 'lodash';
import axios from 'axios';
import EditDialog from './ScheduleEditDialog.vue';
import ScheduleGenerateDialog from '@/views/journals/schedule/ScheduleGenerateDialog.vue';
import CSimpleTable from '@/components/base/table/CSimpleTable.vue';

interface ScheduleData {
    Config: ScheduleConfig;
    Items: ScheduleItem[];
}

interface ScheduleConfig {
    month: number;
    year: number;
}

interface ScheduleItem {
    Date: string;
    Id: number;
    Name: string;
    Post: number;
    ShiftTml: string;
}

@Component({
    components: {
        CSimpleTable,
        ScheduleGenerateDialog,
        EditDialog,
    },
})
export default class Schedule extends Vue {
    @Prop({default: false, type: Boolean}) inSearch!: boolean;

    private data: ScheduleData | null = null;
    private loading: boolean = false;
    private date: Date = new Date(Date.now());
    private items: any = null;
    private datePicker: boolean = false;

    get year() {
        return this.date.getFullYear();
    }

    get month() {
        return this.date.getMonth() + 1;
    }

    get datePickerValue() {
        return this.date.toISOString().substr(0, 10);
    }
    set datePickerValue(value: string) {
        this.date = new Date(value);
    }

    get datePickerBtnText() {
        const month = this.date.getMonth() + 1;
        const year = this.date.getFullYear();
        return String(month).length === 1 ? `0${month}.${year}` : `${month}.${year}`;
    }

    get cardLoading() {
        return this.loading ? 'plywood lighten-1' : null;
    }

    @Watch('data', {deep: true})
    onDataChande(value: ScheduleData) {
        this.items = this.getItems();
    }

    @Watch('date', {immediate: true})
    onDateChange(value: Date) {
        this.getData();
    }

    async getData() {
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 100);
        try {
            const {data} = await this.$http.get(`${this.$api.journals.schedule}/GetAll`, {
                params: {
                    month: this.month,
                    year: this.year,
                },
            });
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    getItems() {
        if (this.data === null) return [];

        const groups = groupBy(this.data.Items, (value: ScheduleItem) => {
            return value.Date;
        });

        const items: any[] = [];
        for (let group in groups) {
            items.push({
                text: group,
                show: true,
                childs: groups[group],
            });
        }

        return items;
    }

    async generateShifts() {
        const options = {
            title: this.$t('Documents.Schedule.GenerateForCurMonth'),
            saveCallback: async (payload: any) => {
                try {
                    const {data} = await this.$http.post(
                        `${this.$api.journals.schedule}/Generate`,
                        {
                            DayScheduleList: payload.daySchedule,
                            StartDate: payload.datePeriod[0],
                            EndDate: payload.datePeriod[1],
                            Year: this.year,
                            Month: this.month,
                        },
                        {is400ErrorHandled: true} as any,
                    );
                    this.data = data;
                    (this.$refs.generateDialog as any).close();
                } catch (e) {
                    (this.$refs.generateDialog as any).setupErrors(e?.response?.data?.errors);
                }
            },
            date: new Date(Date.UTC(this.year, this.month - 1, 1)),
        };
        const CancelToken = axios.CancelToken,
            source = CancelToken.source();
        const request = this.$http.get(`${this.$api.journals.schedule}/GetGenerateData`, {
            params: {
                year: this.year,
                month: this.month,
            },
            cancelToken: source.token,
        });
        (this.$refs.generateDialog as any).openAsync(request, source, options);
    }

    async deleteShifts() {
        if (this.loading || (this.data && this.data.Items.length === 0)) return;
        const timerId = setTimeout(() => {
            this.loading = true;
        }, 150);
        try {
            const {data} = await this.$http.post(
                `${this.$api.journals.schedule}/DeleteMonthShifts?month=${this.month}&year=${this.year}`,
            );
            this.data = data;
        } finally {
            clearTimeout(timerId);
            this.loading = false;
        }
    }

    edit(id: number) {
        if (this.loading) return;
        const cancelRequest = axios.CancelToken.source(),
            request = this.$http.get(`${this.$api.journals.schedule}/GetEdit`, {
                params: {
                    id,
                },
            });
        (this.$refs.editing as any).openAsync(request, cancelRequest, {
            saveCallback: (data: any) => {
                this.save(data);
            },
        });
    }

    async save(model: any) {
        try {
            const {data} = await this.$http.post(
                `${this.$api.journals.schedule}/Save?month=${this.month}&year=${this.year}`,
                model,
            );
            this.data = data;
            (this.$refs.editing as any).close();
        } catch (err) {
            console.error(err);
        }
    }

    select(id: number) {
        this.$emit('search:input', id);
    }
}
